module.exports = __webpack_public_path__ + "static/media/intro.a46a4979.jpg";